import React from 'react';

function About() {
  return (
    <section className="about wrap" id="hash-about">
      <div className="flex-box">
        <div className="flex-left">
          <div className="wrap-title">
            <h2 lang="en">About</h2>
            <p>공유디자이너랩 소개</p>
          </div>
        </div>
        <div className="flex-right">
          <p>소량인쇄, 샘플링이 가능한 0.9M 공유디자이너랩</p>
          <pre>
            {`디자이너들이 모여 디자인 작업에 관련된 노하우를 공유하고 소량의 인쇄물도 자유롭게 샘플링해볼 수 있는 곳입니다.
            개인, 디자이너를 위해 다양한 지류와 폰트를 구비해둔 공유디자이너랩에서 인쇄 샘플을 직접 살펴보며
            높은 품질의 결과물을 얻어갈 수 있습니다.`}<br />
            {`＊공유디자이너랩은 부산경제진흥원에서 지원하는 「2021년 공유경제촉진사업」의 일환으로 운영됩니다.`}<br />
            {`＊공유디자이너랩은 '컨셉셰어오피스 0.9M'내에 위치해 있습니다.`}
          </pre>
          <ul>
            <li>디자이너 노하우 공유</li>
            <li>소량 인쇄물 샘플링</li>
            <li>다양한 지류, 폰트 구비</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default About;
